export function replaceHistoryPath(path: string) {
  if (window.history?.pushState) {
    window.history.pushState({}, "", path);

    // Update canonical tag so that the mobile "Share" feature works properly
    // https://stackoverflow.com/questions/51518379/history-pushstate-does-not-update-url-for-share-button-on-mobile-chrome
    const canonicalLink = document.querySelector("link[rel='canonical']");
    if (canonicalLink) {
      canonicalLink.setAttribute(
        "href",
        location.protocol + "//" + location.host + path
      );
    }
  }
}
